__webpack_require__.p = "/dictionary/";